import services from './_services'

export default {
  getJobBoard () {
    return services.get(process.env.ROOT_API + '/job_board/')
  },
  getPage (filter) {
    return services.getWithParams(process.env.ROOT_API + '/job_board/', filter)
  },
  getJobBoardOccupation (occupation) {
    return services.get(process.env.ROOT_API + '/job_board/occupation_id/' + occupation)
  },
  searchForJobBoardOccupation (occupation) {
    return services.get(process.env.ROOT_API + '/job_board/occupation/' + occupation)
  },
  getJobPost (jobPostID) {
    return services.get(process.env.ROOT_API + '/job_board/' + jobPostID)
  },
  getJobPostingsOfAccount (accountID) {
    return services.get(process.env.ROOT_API + '/job_board/account/' + accountID)
  },
  updateJobPost (jobPostID, data) {
    return services.put(process.env.ROOT_API + '/job_board/' + jobPostID, data)
  },
  createJobPost (data) {
    return services.post(process.env.ROOT_API + '/job_board/', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/jobBoard.js